import React, { useState, useEffect, useRef } from 'react';
import './NumericSlider.css';
import RangeInput from '../RangeInput/RangeInput';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function NumericSlider({ initialValue, showError, errorMessage, rules, onValidate, name, items, minRange, maxRange, label }) {
  const [nativeInputValue, setNativeInputValue] = useState(+initialValue > 0 && +initialValue <= 10 ? +initialValue : 1);
  const [selectedValue, setSelectedValue] = useState(+initialValue > 0 && +initialValue <= 10 ? +initialValue : null);
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [needsValidate, setNeedsValidate] = useState(false);
  const [hasLabels, setHasLabels] = useState(items.filter(item => item.key).length > 0);
  const isValidating = useRef(false);

  if (logComponent('NumericSlider')) { console.debug('NumericSlider render'); }

  useEffect(() => {
    if (logComponent('NumericSlider')) { console.debug('NumericSlider onMount'); }

    validateThis();
  }, [])

  useEffect(() => {
    if (logComponent('NumericSlider')) { console.debug('NumericSlider useEffect [needsValidate]'); }
    if (needsValidate === true) {
      validateThis();
      setNeedsValidate(false);
    }
  }, [needsValidate])

  const validateThis = () => {
    if (logComponent('NumericSlider')) { console.debug('NumericSlider validateThis'); }
    if (isValidating.current) return;
    isValidating.current = true;

    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](selectedValue, rules[rule])
      })
    }
  
    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);

    onValidate({
      name: name,
      isValid: isValidThis,
      value: selectedValue
    });
    isValidating.current = false;
  }

  const updateSelectedValue = (newValue) => {
    if (logComponent('NumericSlider')) { console.debug('NumericSlider updateSelectedNumeric'); }
    setSelectedValue(newValue);
    setNeedsValidate(true);
  }

  return (
    <div className="Numeric-Slider">
      {
        showError && !isValid &&
        <p className="Numeric-Slider__error">{errorMessage}</p>
      }
      <h4 className="Numeric-Slider__heading">
        {label}
        {
          rules && rules.required &&
          <span className="Numeric-Slider__required"> *</span>
        }
      </h4>
      <div className="Numeric-Slider__body">
        <div className="Numeric-Slider__slider">
          <RangeInput
            min={minRange}
            max={maxRange}
            startAtNull={selectedValue === null}
            initial={nativeInputValue}
            onChange={updateSelectedValue}
            onBlur={validateThis}
            showNumbers={true}
            showLabels={hasLabels}
            showGraphics={false}
            items={items}
            alwaysShowOptions={true}
          />
        </div>
      </div>
    </div>
  );
}